import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StorageService } from 'src/app/_services/storage.service';

/** Adds the session bearer token to requests sent to the locker, orders_new, management and user microservices. */
@Injectable()
export class LockerAuthInterceptor implements HttpInterceptor {
  private readonly securedBaseUrls: string[] = [
    environment.microservices.locker,
    environment.microservices.orders_new,
    environment.microservices.management,
    environment.microservices.user,
  ].filter(Boolean);

  constructor(private storageService: StorageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isSecured = this.securedBaseUrls.some((baseUrl) => req.url.startsWith(baseUrl));
    if (!isSecured || req.headers.has('Authorization')) {
      return next.handle(req);
    }

    const token = this.storageService.getItem('currentUser')?.token;
    if (!token) {
      return next.handle(req);
    }

    return next.handle(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
  }
}
